export const SET_DEPARTMENTS = 'SET_DEPARTMENTS';
export const SET_DEPARTMENT_LIST = 'SET_DEPARTMENT_LIST';
export const SET_DEPARTMENT_FILTER_LIST = 'SET_DEPARTMENT_FILTER_LIST';
export const SET_SELECTED_DEPARTMENT = 'SET_SELECTED_DEPARTMENT';

export function setDepartments(departments) {
  return {
    type: SET_DEPARTMENTS,
    payload: departments,
  };
}

export function setDepartmentList(list) {
  return {
    type: SET_DEPARTMENT_LIST,
    payload: list,
  };
}

export function setDepartmentFilterList(filterList) {
  return {
    type: SET_DEPARTMENT_FILTER_LIST,
    payload: filterList,
  };
}

export function setSelectedDepartment(department) {
  return {
    type: SET_SELECTED_DEPARTMENT,
    payload: department,
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/department/actions.js
 **/